import { isPresent } from '@ember/utils';

export default function cleanParams(obj = {}) {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => isPresent(value)),
  );
}
